import { AppexUserScope, useAuthScopes } from '@/lib/useAuthScopes';
import { userWebserviceV2 } from '@/webservices/v2/user';
import { axiosV2 } from '@/main';
import axios from 'axios';

export const initializeAuth = async () => {
    try {
        const queryParams = new URLSearchParams(location.search);

        const { activeScope, scopes, setActiveScope, setScopes } = useAuthScopes();
        let scope = activeScope.value;
        let modified = false;

        const urlToken = queryParams.get('token');
        if (urlToken) {
            localStorage.setItem('api_token', urlToken);
            queryParams.delete('token');
            modified = true;
        }

        const token = localStorage.getItem('api_token');
        if (token) {
            axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
            axios.defaults.headers.common.Authorization = 'Bearer '.concat(token);

            axiosV2.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
            axiosV2.defaults.headers.common.Authorization = 'Bearer '.concat(token);
        }

        const companiesResponse = await userWebserviceV2.getCompanies();
        setScopes(companiesResponse.data.data);

        if (queryParams.has('activeScope')) {
            const rawScope = queryParams.get('activeScope');
            const parsedScope = rawScope ? (JSON.parse(rawScope) as AppexUserScope) : {};
            scope = { ...scope, ...parsedScope };
            queryParams.delete('activeScope');
            modified = true;
        }

        if (scopes.value && scopes.value.length > 0) {
            scope = scopes.value.find(
                (findScope) => findScope.company && scope && scope.company && findScope.company.id === scope.company.id
            );
            if (!scope) {
                scope = scopes.value[0] as AppexUserScope;
            }
        }

        if (!scope) {
            // goToCurrent('auth/logout');
        }

        if (modified) {
            const newUrl =
                window.location.pathname +
                (queryParams.toString() ? `?${queryParams.toString()}` : '') +
                window.location.hash;

            window.history.replaceState({}, '', newUrl);
            // location.reload();
        }

        await setActiveScope(scope as AppexUserScope);

        if (activeScope.value && activeScope.value.company) {
            axios.defaults.headers.common['X-Company-Id'] = activeScope.value.company.id;
            axiosV2.defaults.headers.common['X-Company-Id'] = activeScope.value.company.id;
        }
    } catch (err) {
        console.error(err);
    }
};
